<template>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="switchItems()" :value="this.isLoaded && this.items.length > 0" :caption="this.isLoaded ? 'Показать ' + this.topCount : 'Показать все'" :expandable="items.length > topCount">
      <div
        v-show="isLoading"
        class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-show="!isLoading">
        Изменения в ЕГРИП ({{items.length}})
        <template v-for="item in topItems">
          <div>
            <div>
              <b><a @click="dialogOpen(item)">{{item.code}} </a> </b>
              от {{formats.blank(item.date, formats.formatDate)}}              
            </div>
            <v-flex pl-2>
              <div>{{item.name}}
              </div>
              <!-- <div>{{item.tax.name}}</div> -->
            </v-flex>
          </div>
        </template>      
      </div>  
    </v-panel-title>
    <v-card-text v-show="isLoaded && items.length > 0" class="pt-0">
      <v-flex v-if="items.length===0">
      Данные не найдены.
      </v-flex>                
      <template v-for="item in lastItems">
          <div>
            <div>
              <b><a @click="dialogOpen(item)">{{item.code}} </a> </b>
              от {{formats.blank(item.date, formats.formatDate)}}              
            </div>
            <v-flex pl-2>
              <div>{{item.name}}
              </div>
              <!-- <div>{{item.tax.name}}</div> -->
            </v-flex>
          </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import apimix from '../common/apimix'
  import vPanelTitle from './PanelTitle'
  import vLonerRecordForm from './LonerRecordForm'
  import dialogs from '../common/dialogs'

  export default {
    name: 'v-loner-records-panel',
    components: {vPanelTitle},
    mixins: [apimix],
    data: () => ({
      id: null,
      isLoaded: false,
      isLoading: false
    }),
    props: {
      fillHeight: {
        type: Boolean,
        default: false
      },
      topCount: {
        type: Number,
        default: 2
      },
      records: {
        type: Array,
        default () {
          return []
        }
      }
    },
    watch: {
    },
    computed: {
      ...mapGetters({
      }),
      topItems () {
        return this.items.slice(0, this.topCount)
      },
      lastItems () {
        return this.items.slice(this.topCount)
      },
      items () {
        return this.records
      }
    },
    methods: {
      switchItems () {
        this.isLoaded = !this.isLoaded
        if (this.isLoaded && this.items.length === 0) {
        }
      },
      dialogOpen: function (item) {
        dialogs.register('v-loner-record-form', vLonerRecordForm)
        var fullscreen = this.$vuetify.breakpoint.xsOnly
        var comp = { template: `
          <v-loner-record-form v-on:close="$emit('close')" :fullscreen="fullscreen" :model="model"></v-loner-record-form>
        `,
          data () {
            return {
              model: item,
              fullscreen: fullscreen
            }
          }
        }
        dialogs.modal(comp)
      }
    }
  }

</script>


// WEBPACK FOOTER //
// LonerRecordsPanel.vue?6d0f7ef6